import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { loadSimpleAnalytics } from './services/analytics'

// Candidate-link paths contain a bearer credential. Decide before loading the
// third-party script so its initial page view can never receive that URL.
loadSimpleAnalytics()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
